/** @format */

import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ButtonStyle = styled.button`
  background-color: ${(props: any) =>
    props.variant === "primary" ? "#351182" : "#FFFFFF"};
  color: ${(props: any) =>
    props.variant === "primary" ? "#FFFFFF" : "#351182"};
  border-radius: 0.8125rem;
  padding: 0.65em 2.06em;
  width: 15.625rem;
  height: 3.125rem;

  &:hover {
  scale: 103%;
  transition: 0.5s  ease-in-out; ;

  }
`;

interface ButtonProp {
  value: string;
  toUrl: string;
  variant?: string;
}
export default function Button({ value, toUrl, variant }: ButtonProp) {
  return (
    <Link to={toUrl}>
      <ButtonStyle
        // @ts-ignore
        variant={variant}
      >
        {value}
      </ButtonStyle>
    </Link>
  );
}
